module.exports = __webpack_public_path__ + "static/harp-clipart-7a77fea80d8736c39cffea1ff9b1bb3c.png";